import {createSelector} from 'reselect'

const getSections = sections => sections;

export const getActiveSections = createSelector([getSections], (sections) => {
    return sections.filter(section => !section.deleted);
});


// WEBPACK FOOTER //
// ./src/containers/templates/builder/selectors/active_sections.js